// Presentación de los métodos de pago en la sección "Pagos" del comercio.
// Las etiquetas y logos espejan PAYMENT_PROVIDERS del operador (settings),
// centralizados acá para no acoplar la vista del comercio a la del admin.

const PUBLIC = process.env.PUBLIC_URL ?? '';

// Metadatos de presentación por pasarela. La descripción menciona la entidad que
// procesa el pago (R4: Beartrack solo enruta hacia el medio de pago).
export const GATEWAY_META = {
  flow: {
    label: 'Flow',
    logo: `${PUBLIC}/logo-flow.svg`,
    description: 'Webpay, transferencia y otros medios, con link de pago y QR.',
  },
  khipu: {
    label: 'Khipu',
    logo: `${PUBLIC}/logo-khipu.png`,
    description: 'Transferencia bancaria instantánea entre cuentas (A2A).',
  },
  mercadopago: {
    label: 'Mercado Pago',
    logo: `${PUBLIC}/logo-mercadopago.svg`,
    description: 'Billetera Mercado Pago, tarjetas y transferencia.',
  },
  transbank: {
    label: 'Transbank Webpay',
    logo: `${PUBLIC}/logo-webpay.svg`,
    description: 'Tarjetas de crédito y débito vía Webpay Plus.',
  },
  linkify: {
    label: 'Linkify',
    logo: `${PUBLIC}/linkify-logo.jpg`,
    description: 'Transferencia bancaria con validación automática.',
  },
};

export const gatewayMeta = (provider) =>
  GATEWAY_META[provider] ?? { label: provider, logo: null, description: '' };

// Etiqueta legible de cualquier método (pasarela o no-PSP) para el comprobante.
const PAYMENT_METHOD_LABEL = {
  flow: 'Flow',
  khipu: 'Khipu',
  mercadopago: 'Mercado Pago',
  transbank: 'Transbank Webpay',
  linkify: 'Linkify',
  manual_transfer: 'Transferencia manual',
  cash: 'Efectivo',
};

export const paymentMethodLabel = (method) =>
  PAYMENT_METHOD_LABEL[method] ?? method ?? 'Pasarela de pago';
